import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import {
  VideoCameraOutlined,
  FileTextOutlined,
  TeamOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';

const Dashboard = () => {
  // 模拟数据，后续会从 API 获取
  const stats = {
    totalVideos: 128,
    totalContents: 256,
    totalAccounts: 15,
    publishedToday: 24
  };

  return (
    <div>
      <h1>工作台</h1>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card>
            <Statistic
              title="视频总数"
              value={stats.totalVideos}
              prefix={<VideoCameraOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="文案素材"
              value={stats.totalContents}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="绑定账号"
              value={stats.totalAccounts}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="今日发布"
              value={stats.publishedToday}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={12}>
          <Card title="待发布任务">
            <p>暂无待发布任务</p>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="最近动态">
            <p>系统运行正常</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
